@import '@hevoio/hevo-ui-toolkit/styles/variables';

.jsonEditor {
  padding: 0;
  border-radius: $border-radius-default;
  height: 300px;
  overflow: hidden;
}

.progressBarWrapper {
  margin: -1 *  $spacer * .25 -1 *  $spacer * 1.5 $spacer * .25;
}
